import { type PermissionWithNames } from '@/authorization-sdk';

export const convertServicePermissionToString = ({ serviceId, actionId, featureId }: PermissionWithNames): string => {
  return `${serviceId}_${featureId}_${actionId}`;
};
